import _Dropdown from './Dropdown';

import './style/index.js';

export type { DropdownProps } from './Dropdown';
export * from './type';

export const Dropdown = _Dropdown;

export default Dropdown;
